<template>
  <div class="page-wrap p-3">
    <div class="page-header p-3 mb-3 mt-3">
      <div class="d-flex justify-content-between align-items-center w-100 mb-3">
        <h3>Студенты</h3>
      </div>

      <div class="filters">
        <div>
          <div class="row col-md-9">
            <div class="el-input-group">
              <label for="filterYear" class="form-label col-md-3">
                Год
              </label>
              <div class="col-md-9">
                <select v-model="page.filter.trancheYear" id="filterYear"
                        @change="reloadList()"
                        class="form-select">
                  <option v-for="(year, index) in filterYears" :key="index" :value="year">
                    {{ year }}
                  </option>
                </select>
              </div>
            </div>
          </div>

          <div class="row col-md-9" v-if="isAdmin() || isManagerFC() || isAdminReadOnly()">
            <div class="el-input-group">
              <label for="university" class="form-label col-md-3">
                ВУЗ
              </label>
              <div class="col-md-9">
                <multiselect
                    v-model="page.filter.university"
                    :options="universities"
                    :searchable="true"
                    :closeOnSelect="true"
                    label="nameRu"
                    track-by="universityId"
                    :close-on-select="true"
                    :allow-empty="true"
                    placeholder="Выберите ВУЗ"
                    :multiple="false"
                    :clear-on-select="true"
                    @select="val => {
                      page.filter.universityId = val?.universityId || null;
                      reloadList();
                    }"
                    @remove="val => {
                      page.filter.universityId = null;
                      reloadList();
                    }"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="page-content mt-3 mb-3">
    <div class="page-content-info d-flex align-items-center justify-content-end">
      <b-button v-if="isUniversityManager() || isAdmin()" class="btn btn-success" @click="openCreateDialog">
        Добавить
      </b-button>
    </div>

    <div class="page-content-info d-flex align-items-center justify-content-between">
      <div>Найдено: <span>{{ totalCount }}</span></div>
    </div>

    <b-table striped hover
             :items="items"
             :fields="fields"
             responsive="sm"
             no-local-sorting
             show-sort-labels>
      <template #head(universityName)="data">
        <div class="sortable-container none"
             @click="onSortChanged('universityName')"
             :class="{'ascending': page.sort.universityName === 'ASC', 'descending': page.sort.universityName === 'DESC'}">
          ВУЗ
        </div>
      </template>
      <template #head(academicYear)="data">
        <div class="sortable-container none"
             @click="onSortChanged('trancheYear')"
             :class="{'ascending': page.sort.trancheYear === 'ASC', 'descending': page.sort.trancheYear === 'DESC'}">
          Год
        </div>
      </template>
      <template #head(createdAt)="data">
        <div class="sortable-container none"
             @click="onSortChanged('createdAt')"
             :class="{'ascending': page.sort.createdAt === 'ASC', 'descending': page.sort.createdAt === 'DESC'}">
          Дата создания
        </div>
      </template>
      <template #head(actions)="data">
      </template>

      <template #cell(universityName)="data">
        <a href="#" @click.prevent="onClickItem(data.item)">
          {{ data.item.universityName || 'Сводный (Все ВУЗы)' }}
        </a>
      </template>

      <template #cell(academicYear)="data">{{ data.item.trancheYear }} </template>

      <template #cell(calculatedSum)="data">
        {{ data.item.calculatedSum ? Number(data.item.calculatedSum).toLocaleString('ru-RU', {minimumFractionDigits: 2, maximumFractionDigits: 2}) : '0,00' }}
      </template>


      
      <template #cell(createdAt)="data">{{ formatDate(data.item.createdAt) }} </template>

      <template #cell(actions)="data">
        <div class="action-cell">
          <el-button type="success" title="Скачать Excel"
                     @click="onClickDownload(data.item)">
            <font-awesome-icon :icon="['fas', 'file-excel']"/>
          </el-button>
          <el-button type="danger" title="Удалить"
                     @click="onClickDelete(data.item)"
                     v-if="isAdmin() || isManagerFC() || (isUniversityManager() && data.item.status !== 'APPROVED')">
            <font-awesome-icon :icon="['fas', 'trash']"/>
          </el-button>
        </div>
      </template>
    </b-table>
  </div>
  <div class="page-footer">
    <b-pagination
        v-model="page.partNumber"
        :total-rows="totalCount"
        :per-page="page.countInPage"
        v-on:click="reloadList"
        first-text="<<"
        last-text=">>"
        class="mt-3"
    ></b-pagination>
  </div>

  <b-modal id="create-modal" title="Создать запись" v-model="dialogVisible" @ok="handleCreate" ok-title="Создать" cancel-title="Отмена" :ok-disabled="creating">
    <b-form-group label="Год" label-for="year-select">
      <b-form-select v-model="selectedYear" :options="availableYears" id="year-select"></b-form-select>
    </b-form-group>
  </b-modal>

  <vue-loading :active.sync="isLoading" :is-full-page="true"></vue-loading>
</template>

<script>
import VueLoading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/css/index.css';
import {showErrorNotify, showSuccessNotify} from "@/utils/notificationUtils";
import ueStudentsService from "@/services/ueStudentsService";
import universityService from "@/services/universityService";
import delegationService from "@/services/delegationService";
import Multiselect from "vue-multiselect";
import dayjs from "dayjs";
import { saveAs } from "@/assets/FileSaver.min";

export default {
  name: "UeStudentsListView",
  components: { VueLoading, Multiselect },
  data() {
    const currentYear = new Date().getFullYear();
    return {
      isLoading: false,
      dialogVisible: false,
      creating: false,
      selectedYear: currentYear,
      availableYears: Array.from({length: 8}, (v, i) => 2019 + i),
      selectedUniversity: null,
      universities: [],
      items: [],
      totalCount: 0,
      page: {
        filter: {
          trancheYear: currentYear,
          universityId: null
        },
        sort: { 
          trancheYear: 'DESC',
          universityName: null,
          createdAt: null 
        },
        partNumber: 1,
        countInPage: 10
      },
      fields: [
        { key: 'universityName', label: 'ВУЗ', sortable: true },
        { key: 'academicYear', label: 'Год', sortable: true },

        { key: 'calculatedSum', label: 'Всего', sortable: false },
        { key: 'createdAt', label: 'Дата создания', sortable: true },
        { key: 'actions', sortable: false }
      ],
      filterYears: Array.from({length: 8}, (v, i) => 2019 + i),
    };
  },
  mounted() {
    this.initUniversities();
    this.reloadList();
  },
  methods: {
    isAdmin() {
      return delegationService.isAdmin();
    },
    isAdminReadOnly() {
      return delegationService.isAdminReadOnly();
    },
    isManagerFC() {
      return delegationService.isManagerFC();
    },
    isUniversityManager() {
      return delegationService.isUniversityManager();
    },
    formatDate(dateStr) {
      if (!dateStr) return '';
      return dayjs(dateStr).format('DD.MM.YYYY HH:mm');
    },
    getStatusVariant(status) {
      if (status === 'CREATED') return 'primary';
      if (status === 'IN_PROGRESS') return 'warning';
      if (status === 'APPROVED') return 'success';
      return 'secondary';
    },
    getStatusLabel(status) {
      if (status === 'CREATED') return 'Создан';
      if (status === 'IN_PROGRESS') return 'В работе';
      if (status === 'APPROVED') return 'Утвержден';
      return status;
    },
    initUniversities() {
      if (this.isAdmin() || this.isManagerFC() || this.isAdminReadOnly()) {
        const params = {
          partNumber: 1,
          countInPage: 0,
          filter: {}
        };
        universityService.getAll(params)
            .then(response => {
              this.universities = response.list.sort((a, b) => a.nameRu.localeCompare(b.nameRu));
            });
      }
    },
    async reloadList() {
      this.isLoading = true;
      try {
        const response = await ueStudentsService.getList(this.page);
        this.items = response.list;
        this.totalCount = response.count;
      } catch (e) {
        showErrorNotify('Ошибка при загрузке данных');
      } finally {
        this.isLoading = false;
      }
    },
    onSortChanged(column) {
      this.page.sort = {
        ...this.page.sort,
        [column]: this.page.sort[column] === 'ASC' ? 'DESC' : 'ASC'
      };
      this.reloadList();
    },
    openCreateDialog() {
      this.selectedUniversity = null;
      this.dialogVisible = true;
    },
    async handleCreate(bvModalEvent) {
      bvModalEvent.preventDefault();
      this.creating = true;
      try {
        const dto = {
          trancheYear: this.selectedYear,
          universityId: null // University ID will be determined on the backend by the user token
        };
        const response = await ueStudentsService.create(dto);
        showSuccessNotify('Отчет успешно создан');
        this.dialogVisible = false;
        this.$router.push(`/expenses/students/${response.uuid}`);
      } catch (e) {
        if (e.response && e.response.status === 409) {
          showErrorNotify('Отчет для выбранного года уже существует');
        } else {
          showErrorNotify('Ошибка при создании отчета');
        }
      } finally {
        this.creating = false;
      }
    },
    onClickItem(item) {
      this.$router.push(`/expenses/students/${item.uuid}`);
    },
    async onClickDelete(item) {
      if (confirm('Вы уверены, что хотите удалить этот отчет?')) {
        this.isLoading = true;
        try {
          await ueStudentsService.deleteById(item.uuid);
          showSuccessNotify('Отчет удален');
          this.reloadList();
        } catch (e) {
          showErrorNotify('Ошибка при удалении');
        } finally {
          this.isLoading = false;
        }
      }
    },
    async onClickDownload(item) {
      this.isLoading = true;
      try {
        const response = await ueStudentsService.download(item.uuid);
        const blob = new Blob([response.data], {type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"});
        saveAs(blob, "expenses_students_" + item.uuid + ".xlsx");
      } catch (e) {
        showErrorNotify('Ошибка при скачивании файла');
      } finally {
        this.isLoading = false;
      }
    }
  }
};
</script>

<style scoped>
.row {
  padding-top: 5px;
}

.ascending {
  background-image: url("@/assets/asc.svg") !important;
}

.descending {
  background-image: url("@/assets/desc.svg") !important;
}

.none {
  background-image: url("@/assets/none.svg");
  margin-left: 10px !important;
}

.sortable-container {
  background-position: right calc(0.75rem / 2) center;
  background-repeat: no-repeat;
  background-size: 0.65em 1em;
  vertical-align: middle !important;
  margin-right: 10px !important;
  padding-right: 15px !important;
  cursor: pointer;
}

th div {
  width: 100% !important;
  display: grid !important;
}

.p-3 {
  padding: 0 !important;
}

.action-cell {
  display: flex;
  justify-content: flex-end;
}

.delete-button {
  display: flex;
  align-items: center;
}

.btn-icon {
  font-size: 30px;
  cursor: pointer;
  transition: color 0.3s;
  margin-right: 2px;
}

.btn-excel {
  color: green;
}

.btn-excel:hover {
  color: #85ce61;
}

.btn-edit {
  color: #409eff;
}

.btn-edit:hover {
  color: #66b1ff;
}
</style>


